'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Man';

var EntypoMan = function EntypoMan(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,4c1.104,0,2-0.896,2-2c0-1.105-0.896-2-2-2S8,0.895,8,2C8,3.104,8.896,4,10,4z M15.978,11.583c-0.385-1.775-1.058-4.688-2.042-5.894C12.979,4.516,11.051,4.467,10,4.467h0c-1.051,0-2.979,0.049-3.936,1.222C5.08,6.895,4.407,9.808,4.022,11.583c-0.213,0.983,1.154,1.344,1.511,0.355c0.531-1.473,0.941-2.71,1.839-3.736C7.844,11.109,6.102,16.168,6,19c0,0.552,0.448,1,1,1c0.426,0,0.79-0.266,0.934-0.642C8.391,17.771,10,13.355,10,13.355l0,0l0,0c0,0,1.609,4.416,2.066,6.003C12.21,19.734,12.574,20,13,20c0.552,0,1-0.448,1-1c-0.102-2.832-1.844-7.891-1.372-10.797c0.898,1.026,1.308,2.263,1.839,3.736C14.823,12.927,16.191,12.566,15.978,11.583z' })
    );
};

exports.default = EntypoMan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Man.js
// module id = 666
// module chunks = 168707334958949